export default {
  getClient: (state) => state.client,
};
